module.exports = __webpack_public_path__ + "static/media/ramenSpace.2f9c65af.png";